const styles = {
  root: {
    background: '#FDFDFD',
    height: '100vh',
    boxSizing: 'border-box',

    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    '& .floating-action': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 16,
      paddingTop: 8,
    },
  },
};

export default styles;
